import React, {useEffect, useRef, useState} from "react";
import {Table, Tooltip, Popconfirm, DefaultTablePagination, notification} from "../../components/Elements/appUtils";
import {userListFxn,deleteUserFxn} from "./actions";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";

let filterInit = {
    name: "",
    menu: "",
    categoryId: ""
}
const PasswordCell = ({ item }) => {
    const [isVisible, setIsVisible] = useState(false);

    if (item.userType === "admin") return <span>-</span>;
    if (!item.displayPassword) return <span>-</span>;

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ minWidth: "90px", padding: "4px 10px", borderRadius: "6px", background: "#f5f5f5", display: "inline-block", fontSize: "13px", lineHeight: "20px", textAlign: "center" }}>
                {isVisible ? item.displayPassword : "••••••••"}
            </span>
            <a
                className="empty_btn"
                onClick={() => setIsVisible(!isVisible)}
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "24px", height: "24px", cursor: "pointer" }}
            >
                <i className={`fa ${isVisible ? "fa-eye-slash" : "fa-eye"}`} />
            </a>
        </div>
    );
};
function UserList() {
    let dispatch = useDispatch()
    let tableRef = useRef();
    const navigate = useNavigate();
    let [filter, setFilter] = useState(filterInit)
    const [categoryList, setCategoryList] = useState([])
    const [visiblePasswordId, setVisiblePasswordId] = useState("");
    const [k, setK] = useState();
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                const data = await userListFxn({...params, regExFilters: ["name"]});
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };


    const search = async () => {
        if (tableRef.current) {
            tableRef.current.reload();
        }
    };
    const handleDelete = async (_id) => {
        try {
            const data = await dispatch(deleteUserFxn({_id}));

            if (data && !data.error) {
                if (tableRef.current) {
                    tableRef.current.reload();
                }
            } else {
                notification.error({
                    message: data?.message || "Unable to delete user",
                });
            }
        } catch (error) {
            console.error("Delete user error:", error);
            notification.error({
                message: "Something went wrong while deleting user",
            });
        }
    };


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },

        {
            title: "Email / Username",
            dataIndex: "email",
            key: "email",
        },
        {
            title:"Designation",
            dataIndex:"userType",
            key:"userType"
        },
        // {
        //     title: "Password",
        //     dataIndex: "displayPassword",
        //     key: "displayPassword",
        //     render: (text, item) => {
        //         if (item.userType === "admin") {
        //             return "-";
        //         }
        //
        //         const isVisible = visiblePasswordId === item._id;
        //         const passwordText = item.displayPassword || "";
        //
        //         return (
        //             <div
        //                 style={{
        //                     display: "flex",
        //                     alignItems: "center",
        //                     gap: "8px",
        //                 }}
        //             >
        //         <span
        //             style={{
        //                 minWidth: "90px",
        //                 padding: "4px 10px",
        //                 borderRadius: "6px",
        //                 background: "#f5f5f5",
        //                 display: "inline-block",
        //                 fontSize: "13px",
        //                 lineHeight: "20px",
        //                 textAlign: "center",
        //             }}
        //         >
        //             {isVisible ? passwordText : "••••••••"}
        //         </span>
        //
        //                 {passwordText ? (
        //                     <a
        //                         className={"empty_btn"}
        //                         onClick={() => {
        //                             setVisiblePasswordId(isVisible ? "" : item._id);
        //                         }}
        //                         style={{
        //                             display: "inline-flex",
        //                             alignItems: "center",
        //                             justifyContent: "center",
        //                             width: "24px",
        //                             height: "24px",
        //                         }}
        //                     >
        //                         <i className={`fa ${isVisible ? "fa-eye-slash" : "fa-eye"}`} />
        //                     </a>
        //                 ) : null}
        //             </div>
        //         );
        //     },
        // },
        {
            title: "Password",
            dataIndex: "displayPassword",
            key: "displayPassword",
            render: (text, item) => <PasswordCell item={item} />,
        },

        // {
        //     title: "Address",
        //     dataIndex: "address",
        //     key: "address"
        // },
        // {
        //     title: "Tables",
        //     dataIndex: "tables",
        //     key: "tables",
        //     render: (item) => {
        //         return item && item.length ? item.join(', ') : null
        //     }
        // },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (v, item) => {
                if (item.userType === "admin") {
                    return null;
                }
                return (
                    <>
                        <a
                            className={"empty_btn"}
                            onClick={() => {
                                navigate(`/editUser?_id=${item._id}`);
                            }}
                        >
                            <i className={"fa fa-edit far"}/>
                        </a>

                        <Popconfirm
                            title="Are you sure you want to delete this user?"
                            onConfirm={() => handleDelete(item._id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <a className={"empty_btn"} style={{marginLeft: "10px"}}>
                                <i className={"fa fa-trash"}/>
                            </a>
                        </Popconfirm>
                    </>
                );
            },
        },

    ];


    return (
        <PageHeader
            title={"User"}
            extraLink={[
                {
                    name: "Add User",
                    link: "/add-user",
                },
            ]}
        >


            <div className="card mb-0">
                <div className="table-responsive">
                    <Table
                        apiRequest={apiRequest}
                        columns={columns}
                        pagination={DefaultTablePagination()}

                        ref={tableRef}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default UserList;
